import { findSelected } from '@/utils/resultsHelper';
import { attachmentIcon } from '@/datasets/attachments/helper';
import { attachmentRequestReasons } from './constants';

export const sanitizeAttachments = (attachments) => (
  attachments?.results ? findSelected(attachments.results)
    .map((attachment) => ({
      attachment_id: attachment.id,
      dataset_code: attachment.metadata.dataset_code,
    })) : []);

const attachmentReasonIcon = (attachment) => ({
  ...attachmentIcon(attachment),
  message: `request.list.attachments.reason.${attachment.reason}`,
  ...{
    [attachmentRequestReasons.REQUIRED_AT_CREATION]: { className: 'positive' },
    [attachmentRequestReasons.REQUIRED_AT_TRANSFER]: { className: 'positive' },
  }[attachment.reason],
});

export default attachmentReasonIcon;
